export default __webpack_public_path__ + "static/media/Gloves of Effulgent Devotion.2e857302.jpg";